import { render, staticRenderFns } from "./download_home.vue?vue&type=template&id=6c87e406"
import script from "./download_home.vue?vue&type=script&lang=js"
export * from "./download_home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports